import { useState } from "react";

/* COMPONENTS */
import DatePicker from "react-datepicker";


/* CSS */
import '../../../../styles/stepper.css'


const Page4 = ({ formData,setFormData, nextPage, prevPage }) => {


  const [errors, setErrors] = useState({});
  const validate = () => {
    const newErrors = {};
  
    const fields = [
      'amount',
      'datePaid',
    ];
  
    const formatFieldName = (field) => {
      // Split camelCase string into words and capitalize each word
      return field
        .replace(/([a-z0-9])([A-Z])/g, '$1 $2') // Split camelCase (e.g., "firstName" -> "First name")
        .replace(/^./, (str) => str.toUpperCase());  // Capitalize the first letter
    };
  
    // Validate the fields
    fields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = `${formatFieldName(field)} is required.`; // Dynamic error message
      } else if (field === 'amount') {
        // Check if amount is a valid number (integer, float, or decimal)
        const amountValue = formData[field];
        if (isNaN(amountValue) || amountValue === '') {
          newErrors[field] = `${formatFieldName(field)} must be a valid amount (Remove commas).`;
        } else if (!/^\d+(\.\d+)?$/.test(amountValue)) {
          // Check if amount is a valid float or integer with a decimal point (optional)
          newErrors[field] = `${formatFieldName(field)} must be a valid amount (Remove commas).`;
        }
      }
    });
  
    // Update state with errors
    setErrors(newErrors);
  
    // Return true if no errors, false otherwise
    return Object.keys(newErrors).length === 0;
  };
  
  

  const handleNext = () => {
    if (validate()) {
      nextPage();
    }
  };
 

  const handleDateChange = (date) => {
    setFormData({
      ...formData,
      datePaid: date ? date : "",
    });
  };

 


 
  return (
    <div className="step-content">
      <div>
        <div className="row mb-4">
          {/* PERSONAL INFO */}
          <div className="col-md-12">

            <div className="d-flex flex-wrap justify-content-between align-items-center">
              <div className="d-flex flex-column justify-content-center">
                <h4 className="mb-1 mt-3">PAYMENT</h4>
                <p className="text-muted">Payment Info</p>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6 mb-2">
                <label className="form-label text-info" htmlFor="txtAmount" >
                  Amount
                </label>
                <input
                  type="number"
                  className={`form-control mt-n1 ${errors.amount && 'is-invalid'}`}
                  id="txtAmount"
                  value={formData.amount}
                  name="payment_amount"
                  placeholder="Enter Amount"
                  aria-label="Amount"
                  onChange={(e) => setFormData({ ...formData, amount: e.target.value })}
                />
                {errors.amount && <div className="invalid-feedback d-block blink">{errors.amount}</div>}

              </div>

              <div className="col-md-6 mb-2">
                <label className="form-label text-info" htmlFor="txtReferenceNumber" >
                  Reference Number
                </label>
                <input
                  type="text"
                  className={`form-control mt-n1 ${!formData.referenceNo && errors.referenceNo && 'is-invalid'}`}
                  id="txtReferenceNumber"
                  value={formData.referenceNo}
                  name="reference_no"
                  placeholder="Enter Reference Number"
                  aria-label="Reference Number"
                  onChange={(e) => setFormData({ ...formData, referenceNo: e.target.value })}
                />
                {!formData.referenceNo && errors.referenceNo && <div className="invalid-feedback d-block blink">{errors.referenceNo}</div>}

              </div>


              <div className="col-md-6 mb-2">
                <label className="form-label text-info" htmlFor="txtDatePaid" >
                  Date of Payment
                </label>


                <DatePicker
                  id="txtDatePaid"
                  name="date_created"
                  className={`form-control flatpickr-input active w-100 ${!formData.datePaid && errors.datePaid && 'is-invalid'}`}
                  placeholderText="YYYY-MM-DD"

                  selected={formData.datePaid}
                  onChange={handleDateChange}

                  dateFormat="yyyy-MM-dd"
                />


                {!formData.datePaid && errors.datePaid && <div className="invalid-feedback d-block blink">{errors.datePaid}</div>}

              </div>


              <div className="col-md-6 mb-2">
                <label className="form-label text-info mb-1" htmlFor="sel_payment_method" >
                  Payment Method
                </label>

                <select
                  id="sel_payment_method"
                  className={`select2 form-select ${!formData.paymentMethod && errors.paymentMethod && 'is-invalid'}`}
                  data-placeholder="Select Payment Method"
                  value={formData.paymentMethod}
                  name="payment_method"
                  onChange={(e) => setFormData({ ...formData, paymentMethod: e.target.value })}
                >
                  <option value="">Payment Method</option>
                  <option value="CASH" selected>Cash</option>
                  <option value="BANK">Bank</option>
                  <option value="DEBIT CARD">Debit Card</option>
                  <option value="CREDIT CARD">Credit Card</option>
                </select>
                {!formData.paymentMethod && errors.paymentMethod && <div className="invalid-feedback d-block blink">{errors.paymentMethod}</div>}
              </div>



              <div className="col-md-12 mb-2">
                <label className="form-label text-info" htmlFor="txtDescription" >
                  Description <span className="text-danger">( Optional )</span>
                </label>
                <textarea
                  id="txtDescription" className="form-control"
                  value={formData.description}
                  name="status_description"
                  placeholder="Enter Description"
                  aria-label="Date of Payment"
                  onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                  rows="2">
                </textarea>
              </div>
            </div>



          </div>
        </div>


        <div className="col-12 d-flex justify-content-between">
          <button className="btn btn-label-secondary btn-prev" onClick={prevPage}>
            <i className="bx bx-chevron-left bx-sm ms-sm-n2" />
            <span className="align-middle d-sm-inline-block d-none">
              Previous
            </span>
          </button>
          <button className="btn btn-primary btn-next" onClick={handleNext}>
            <span className="align-middle d-sm-inline-block  d-none  me-sm-1">
              Next
            </span>
            <i className="bx bx-chevron-right bx-sm me-sm-n2" />
          </button>
        </div>


      </div>


    </div>
  );
};

export default Page4;
